import type { ReactNode } from 'react';

export interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({
  icon = '📄',
  title,
  description,
  action,
}: EmptyStateProps): ReactNode {
  return (
    <div className="empty">
      <div className="big" aria-hidden="true">
        {icon}
      </div>
      <b>{title}</b>
      {description ? <p>{description}</p> : null}
      {action}
    </div>
  );
}
